export default function Features() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: 'Lightning-Fast Speeds',
      description: 'Experience blazing-fast connection speeds with our optimized server network. Stream, download, and browse without any lag or buffering.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our worldwide server locations. Connect to the server closest to you for optimal performance.'
    },
    {
      icon: 'ri-devices-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Compatible with Windows, Mac, iOS, Android, and Linux systems.'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Kill Switch Protection',
      description: 'Automatic kill switch ensures your data never leaks if your VPN connection drops unexpectedly, keeping you safe at all times.'
    },
    {
      icon: 'ri-infinity-line',
      title: 'No Bandwidth Limits',
      description: 'Enjoy unlimited bandwidth with no restrictions. Download, stream, and browse as much as you want without any throttling.'
    },
    {
      icon: 'ri-lock-password-line',
      title: 'DNS Leak Protection',
      description: 'Advanced DNS leak protection ensures your online activities remain completely private and secure from prying eyes.'
    }
  ];

  return (
    <section id="features" className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-12">
        <div className="mb-16">
          <p className="text-sm uppercase tracking-widest text-gray-500 mb-4">Features</p>
          <h2 className="text-6xl font-bold text-gray-900 leading-tight">
            Why Choose<br />Our VPN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-3xl p-10 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-5xl text-cyan-500`}></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-base text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
